import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

class GetDuplicatesCountAPICall extends APICallV4 {
    _method = 'duplicates/count';
    _type: Method = 'get';
    _retriesCount = 0;
}

export const getDuplicatesCountCall = () => new GetDuplicatesCountAPICall().makeRequest();
